import { AUJS_FORMS } from '@app/forms/shared/aujs-forms';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Form } from '@app/forms/form.model';
import { FormService, OpenFormTarget } from '@app/forms/shared/forms.service';
import { Logger } from '@app/logger/logger';
import { hasValue } from '@app/shared/comparison-helpers.service';
import { WindowService } from '@app/shared/window.service';
import { MatDialog } from '@angular/material/dialog';
import { YesNoDialogComponent } from '@app/shared/dialogs/yes-no-dialog.component';

@Component({
  selector: 'acs-form-link',
  templateUrl: './form-link.component.html'
})
export class FormLinkComponent implements OnChanges {
  @Input() formId: string;
  @Input() showIcon: boolean;
  @Input() useLongName: boolean;

  public form: Form;
  public displayName: string;

  constructor(
    private formService: FormService,
    private log: Logger,
    private windowService: WindowService,
    private matDialog: MatDialog
  ) {}

  ngOnChanges(onChangesObj: SimpleChanges): void {
    if (typeof onChangesObj !== 'undefined') {
      if (hasValue(onChangesObj.formId)) {
        this.form = AUJS_FORMS[onChangesObj.formId.currentValue];

        if (hasValue(onChangesObj.showIcon)) {
          this.showIcon = onChangesObj.showIcon.currentValue;
        }

        // Handle missing forms.
        if (typeof this.form === 'undefined' || this.form === null) {
          if (this.formId !== 'md-menu-divider') {
            this.log.warn('Form not found for link: ' + this.formId);
          }

          this.form = this.formService.getFormWithParams({
            enabled: false,
            id: undefined,
            legacy: true,
            name: this.formId
          });
        }
      }

      if (hasValue(onChangesObj.useLongName) && onChangesObj.useLongName.currentValue === true) {
        this.displayName = this.form.longName;
      } else {
        this.displayName = this.form.name;
      }
    }
  }

  public openForm(ev: MouseEvent): void {
    const currentForm = this.formService.getCurrentForm();

    if (
      !this.windowService.isCurrentWindowPinned() &&
      currentForm &&
      currentForm.isDirty &&
      !this.form.legacy
    ) {
      this.matDialog
        .open(YesNoDialogComponent, {
          data: {
            title: 'Unsaved Changes',
            content: 'There are unsaved changes. How do you want to open the new form?',
            confirmText: 'New Window',
            denyText: 'Current Window',
            includeCancel: true
          },
          width: '45vw',
          panelClass: ['acs-dialog-non-padded']
        })
        .afterClosed()
        .subscribe((openInNewWindow) => {
          if (openInNewWindow !== undefined) {
            this.formService.openForm(
              this.form,
              openInNewWindow ? OpenFormTarget.NewTab : OpenFormTarget.SameWindow
            );
          }
        });
    } else {
      this.formService.openForm(
        this.form,
        this.windowService.isCurrentWindowPinned() || ev.ctrlKey
          ? OpenFormTarget.NewTab
          : OpenFormTarget.SameWindow
      );
    }
  }
}
